function getCookie(name: string): string | null {
  const match = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
}

const COOKIE_KEYS = ['business-unit'];

export function readFromStorage(key: string): string | null {
  if (COOKIE_KEYS.includes(key)) return getCookie(key);
  return localStorage.getItem(key);
}

export function writeToStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}

export function removeFromStorage(key: string): void {
  localStorage.removeItem(key);
}
